import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from './components/layout/layout.module';
import { AgGridModule } from 'ag-grid-angular';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { environment } from '../environment';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { PlaidComponent } from './components/admin-components/tools/plaid/plaid.component';
import { DynamicSQLGridComponent } from './components/admin-components/admin-grids/dynamic-sql-grid/dynamic-sql-grid.component';
import { FormsModule } from '@angular/forms';
import { ViewGridComponent } from './components/admin-components/admin-grids/viewgrid/viewgrid.component';
import { QBIntercompanyComponent } from './components/admin-components/admin-grids/qb-intercompany/qb-intercompany.component';
import { CheckboxCellEditorComponent } from './components/admin-components/admin-grids/dynamic-sql-grid/checkbox-cell-editor/checkbox-cell-editor.component'; 
import { HourglassComponent } from './components/admin-components/hourglass/hourglass.component';
import { TabEntryComponent } from './components/admin-components/hourglass/tab-entry/tab-entry.component';
import { TabCalendarComponent } from './components/admin-components/hourglass/tab-calendar/tab-calendar.component';
import { TabCalendarMultiComponent } from './components/admin-components/hourglass/tab-calendar-multi/tab-calendar-multi.component';
import { TabSettingsComponent } from './components/admin-components/hourglass/tab-settings/tab-settings.component';
import { FormTasksEntryComponent } from './components/admin-components/hourglass/form-tasks-entry/form-tasks-entry.component';
import { TabTasksGridComponent } from './components/admin-components/hourglass/tab-tasks-grid/tab-tasks-grid.component';
import { TabSendWeeklyUpdateComponent } from './components/admin-components/hourglass/tab-send-weekly-update/tab-send-weekly-update.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarSlimComponent } from './components/admin-components/calendar-slim/calendar-slim.component';
import { FormEntryComponent } from './components/admin-components/hourglass/form-entry/form-entry.component';
import { TabHelpComponent } from './components/admin-components/hourglass/tab-help/tab-help.component';
import { TabTaskManagerComponent } from './components/admin-components/hourglass/tab-task-manager/tab-task-manager.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { WelaraAcademyComponent } from './components/user-components/welara-academy/welara-academy.component'
import { LicenseManager } from 'ag-grid-enterprise';
import { GoogleChartsModule } from 'angular-google-charts';
import { setAgGridLicense } from './config/ag-grid-license';
import { DynmacicsqlgridmodalComponent } from './components/admin-components/admin-grids/dynamic-sql-grid/dynmacicsqlgridmodal/dynmacicsqlgridmodal.component'
import { MinutesComponent } from './components/admin-components/minutes/minutes.component'
import { ExternalPartyComponent } from './components/admin-components/minutes/form-party-external/form-party-external.component';
import { TabBillingReviewGridComponent } from './components/admin-components/hourglass/tab-billing-review-grid/tab-billing-review-grid.component';
import { TabHourglassToolsComponent } from './components/admin-components/hourglass/tab-tools/tab-tools.component';
import { PfsComponent } from './components/client-components/pfs/pfs.component';
import { PfsSummaryComponent } from './components/client-components/pfs/pfs-summary/pfs-summary.component';
import { PfsChartsComponent } from './components/client-components/pfs/pfs-charts/pfs-charts.component';
import { PfsAllocationComponent } from './components/client-components/pfs/pfs-allocation/pfs-allocation.component';
import { PfsHoldingsListComponent } from './components/client-components/pfs/pfs-holdings-list/pfs-holdings-list.component';
import { PfsViewGridComponent } from './components/client-components/pfs/pfs-view-grid/pfs-view-grid.component';
import { PfsClientChartsComponent } from './components/client-components/pfs/pfs-client-charts/pfs-client-charts.component';
import { PfsDashboardComponent } from './components/client-components/pfs/pfs-dashboard/pfs-dashboard.component';
import { TeamsComponent } from './components/admin-components/hourglass/teams/teams.component';
import { BillingReviewPivotGridComponent } from './components/admin-components/billing-review-pivot-grid/billing-review-pivot-grid.component';
import { SQLMonitorComponent } from './components/admin-components/sql-monitor/sql-monitor.component';
import { TaxLotsComponent } from './components/admin-components/tools/tax-lots/tax-lots.component';
import { TokenUxComponent } from './components/admin-components/tools/token-ux/token-ux.component';
import { SecureMessagingComponent } from './components/client-components/smc/smc.component';
import { AdminDashboardComponent } from './components/admin-components/admin-dashboard/admin-dashboard.component';
import { UserDashboardComponent } from './components/user-components/user-dashboard/user-dashboard.component';
import { ExcelUploadComponent } from './components/admin-components/excel-upload-component/excel-upload.component';
import { ClientFilesComponent } from './components/client-components/client-files/client-files.component';
import { DynamicSqlColumnAdderComponent } from './dynamic-sql-column-adder/dynamic-sql-column-adder.component';
import { GoogleDriveAccessComponent } from './components/user-components/google-drive-access/google-drive-access.component';
import { BillingComponent } from './components/admin-components/billing/billing.component';
import { BillingConfigurationComponent } from './components/admin-components/billing-configuration/billing-configuration.component';
import { BillingGeneratorComponent } from './components/admin-components/billing-generator/billing-generator.component';
import { BillingQbRefreshComponent } from './components/admin-components/billing-qb-refresh/billing-qb-refresh.component';
import { BtcPriceTrackerComponent } from './components/user-components/btc-price-tracker/btc-price-tracker.component';
import { TradingDashboardComponent } from './components/user-components/trading-dashboard/trading-dashboard.component';
import { NgChartsModule } from 'ng2-charts';
import { TradingDashboardRealizedPnlComponent } from './components/user-components/trading-dashboard/trading-dashboard-realized-pnl/trading-dashboard-realized-pnl.component';
import { TradingDashboardSummaryComponent } from './components/user-components/trading-dashboard/trading-dashboard-summary/trading-dashboard-summary.component';
import { UsersComponent } from './components/admin-components/tools/users/users.component';

import { EditorModule} from '@tinymce/tinymce-angular';
import { RegisterYubikeyComponent } from './components/client-components/yubi/register_yubi.component';

setAgGridLicense();

@NgModule({
  declarations: [
    AppComponent,
    PlaidComponent,
    DynamicSQLGridComponent,
    ViewGridComponent,
    QBIntercompanyComponent,
    CheckboxCellEditorComponent,
    CalendarSlimComponent,
    HourglassComponent,
    TabEntryComponent,
    TabCalendarComponent,
    TabCalendarMultiComponent,
    TabSettingsComponent,
    FormTasksEntryComponent,
    TabTasksGridComponent,
    FormEntryComponent,
    TabSendWeeklyUpdateComponent,
    TabHelpComponent,
    WelaraAcademyComponent,
    DynmacicsqlgridmodalComponent,
    MinutesComponent,
    ExternalPartyComponent,
    TabBillingReviewGridComponent,
    TabHourglassToolsComponent,
    PfsComponent,
    PfsSummaryComponent,
    PfsChartsComponent,
    PfsAllocationComponent,
    PfsHoldingsListComponent,
    PfsViewGridComponent,
    PfsClientChartsComponent,
    PfsDashboardComponent,
    TeamsComponent,
    TaxLotsComponent,
    TokenUxComponent,
    BillingReviewPivotGridComponent,
    TabTaskManagerComponent,
    SQLMonitorComponent,
    SecureMessagingComponent,
    AdminDashboardComponent,
    UserDashboardComponent,
    ExcelUploadComponent,
    ClientFilesComponent,
    DynamicSqlColumnAdderComponent,
    GoogleDriveAccessComponent,
    BillingGeneratorComponent,
    BtcPriceTrackerComponent,
    TradingDashboardComponent,
    TradingDashboardRealizedPnlComponent,
    TradingDashboardSummaryComponent,
    UsersComponent,
    BillingConfigurationComponent,
    RegisterYubikeyComponent,
    BillingQbRefreshComponent,
    BillingComponent
  ],
  imports: [
    LayoutModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    AgGridModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    MatSnackBarModule,
    MatTableModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    FullCalendarModule,
    NgMultiSelectDropDownModule,
    GoogleChartsModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)), // Initialize Firebase App
    provideAnalytics(() => getAnalytics()),
    NgChartsModule,
    EditorModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
